import React, { useContext, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import { verifyEmail } from 'features/auth/actions'
import { selectAuthCommunication } from 'features/auth/selectors'

import { useModalContext } from '@bcraft-frontend-lib/core'

import { Spinner } from 'components/Spinner'

type VerifyEmailParams = {
  token: string
}

export const VerifyEmailPage = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { pushNewModal } = useModalContext()

  const { token } = useParams<VerifyEmailParams>()

  const { isLoading } = useSelector(selectAuthCommunication, shallowEqual).verifyEmail

  const verifyEmailCallback = () => {
    history.push(ROUTE_URLS.MAIN())
    pushNewModal(MODAL_ROUTE_URLS.VERIFY_EMAIL_SUCCESS())()
  }

  const verifyEmailErrorCallback = () => {
    history.push(ROUTE_URLS.MAIN())
  }

  useEffect(() => {
    dispatch(
      verifyEmail(
        { token },
        {
          callback: verifyEmailCallback,
          errorCallback: verifyEmailErrorCallback,
        },
      ),
    )
    verifyEmailCallback()
  }, [token])

  return <Spinner isLoading={isLoading} />
}
